import { Box, VStack } from 'native-base';
import React from 'react';

import OfferCard from 'app/components/OfferCard';
import { AttractionContent } from 'app/hooks/useAttraction';

export type AttractionDetailsOffersUpgradesProps = {
  attraction: NonNullable<AttractionContent>;
  productContentKey: string;
};

export default function AttractionDetailsOffersUpgrades({
  attraction,
  productContentKey,
}: AttractionDetailsOffersUpgradesProps) {
  return (
    <Box testID="AttractionDetailsOffersUpgrades">
      <VStack alignItems="flex-start" space="4">
        {attraction.offers?.map((offer) => (
          <OfferCard key={offer.id} offer={offer} productContentKey={productContentKey} w="full" />
        ))}
      </VStack>
    </Box>
  );
}
